import { useAppUser } from "../../contexts/user-context/UserContext";
import { useState, useEffect } from "react";
import { UserPrivilege } from "../constants/Constant";

export function usePermission(privilege: UserPrivilege) {
  const appUser = useAppUser();
  const [canActivate, setCanActivate] = useState(false);

  useEffect(() => {
    if (!appUser.userRole.isModerator && appUser.userRole.isMember) {
      const permission = appUser.permissions?.find(
        (p) => p.privilege === privilege
      );
      permission !== undefined ? setCanActivate(true) : setCanActivate(false);
    } else {
      setCanActivate(true);
    }
  }, [privilege, appUser.userRole, appUser.permissions]);

  return canActivate;
}
